import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  TemplateRef
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormArray, FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import * as _ from "underscore";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { GUID } from "./../../guid";
import { MatDialog } from "@angular/material";
import { PropertiesDialogComponent } from "src/app/page/field-layout/properties-dialog/properties-dialog.component";

@Component({
  selector: "app-refinedlayoutnew",
  templateUrl: "./refinedlayoutnew.component.html",
  styleUrls: ["./refinedlayoutnew.component.scss"]
})
export class RefinedlayoutnewComponent implements OnInit {
  @ViewChild("aliasDialog", { static: false }) aliasDialog!: TemplateRef<any>;
  @ViewChild("attributesDialog", { static: false })
  attributesDialog!: TemplateRef<any>;

  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;
  profileId = "";
  metaobjectId = "";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  publicAccess = false;
  visibleMeChecked = false;
  visibleAllChecked = true;
  mode = "New";
  allFields: any;
  // allFields: any[] = [];

  guid: GUID;
  metalayout: any;
  metaLayoutButtonId = "";
  metaProfileLayoutId = "";
  metaLayoutGroupId = "";
  metaLayoutGroupFieldId = "";
  metaProfileLayoutWebId = "";
  buttons = [];
  recordTypes = [];
  queues = [];
  queueList = [];
  fields = [];
  fieldList = [];
  operatorList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false }
  ];
  layoutTypeSelect = [
    { value: "Refine", label: "Refine Layout" },
    { value: "Selection", label: "Selection Layout" }
  ];
  CategorySelect = [
    { value: "DEFAULT", label: "DEFAULT" },
    { value: "COMPACT", label: "COMPACT" },
    { value: "MOBILE", label: "MOBILE" }
  ];

  DeviceTypeSelect = [
    { value: "WEB", label: "WEB" },
    { value: "MOBILE", label: "MOBILE" }
  ];

  picklistValueList = [];

  firstfieldsToDo = [];
  firstfieldsDone = [];

  secondfieldsToDo = [];
  secondfieldsDone = [];

  firstbuttonsToDo = [];
  firstbuttonsDone = [];

  secondbuttonsToDo = [];
  secondbuttonsDone = [];

  COMMON_BUTTONS = this.appConfig.COMMON_BUTTONS;

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    aliasname: "",
    id: "",
    displayname: "",
    viewname: "",
    layouttype: "",
    name: "",
    publicaccess: false,
    active: true,
    attributes: {},

    targeturl: "",
    columncount: 4,
    tabkeyorder: "L-R",
    hascustomview: false,
    clonable: false,
    editable: true,
    deletable: false,
    haskanbanview: true,
    searchtext: "",
    sortby: "createdon",
    sortorder: "desc",
    sinceversionseq: 0,
    deprecatedversionseq: 0,
    category: "",
    devicetype: ""
  });
  attributeForm: FormGroup;

  filterForm: FormGroup;
  filteritems: FormArray;
  metaobjectList: any;
  dialogRef: any;
  data: any;
  aliasForm: FormGroup;
  modifieddate: any;
  modifiedby: any;
  attributesdialogRef: any;
  metaProfileLayouts: any;
  metaProfileLayoutWebs: any;

  labelChanged() {
    var txtlabel = this.detailForm.controls["displayname"].value.trim();
    console.log("txtlabel", txtlabel);
    //if(this.detailForm.controls['viewname'].value.trim() == '')
    //{
    txtlabel = txtlabel.replace(/\w\S*/g, function (txt: string) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    // txtlabel = txtlabel.replace(/ /g, "_");
    // this.detailForm.controls["viewname"].setValue(txtlabel);
    //}
  }

  fieldSelected(
    event: {
      id: any;
      fieldtype: any;
      options: string;
      relatedfieldname: any;
      metaobjectname: any;
    },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("relatedfieldname").setValue(event.relatedfieldname);
        c.get("metaobjectname").setValue(event.metaobjectname);
        c.get("options").setValue(event.options);
        if (c.get("fieldoperator").value == "") {
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    if (this.filteritems != null && this.filteritems.length < 10) {
      // this.addFilterItem("", "", "", "", "", "");
      this.addFilterItem("", "", "", [], "", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }

  // createItem(
  //   id: any,
  //   name: any,
  //   ftype: any,
  //   opt: any,
  //   opr: any,
  //   vl: any,
  //   flogic: string
  // ): FormGroup {
  //   return this.fb.group({
  //     //fieldlist: fldlist,
  //     //operatorlist: oplist,
  //     fieldid: id,
  //     fieldname: name,
  //     fieldtype: ftype,
  //     options: opt,
  //     fieldoperator: opr,
  //     fieldvalue: vl,
  //     filterlogic: flogic,
  //   });
  // }

  // addFilterItem(
  //   id: string,
  //   name: string,
  //   ftype: string,
  //   opt: string | any[],
  //   opr: string,
  //   vl: string,
  //   flogic = "AND"
  // ): void {
  //   this.filteritems = this.filterForm.get("filteritems") as FormArray;
  //   this.filteritems.push(
  //     this.createItem(id, name, ftype, opt, opr, vl, flogic)
  //   );
  //   this.picklistValueList.push([]);
  // }

  createItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    typ: any,
    vl: any,
    flogic: string,
    relfieldname: any,
    metaobjectname: any
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      fieldoperator: opr,
      type: typ,
      fieldvalue: vl,
      filterlogic: flogic,
      relatedfieldname: relfieldname,
      metaobjectname: this.metaobjectName
      // filtertype: "",
      // errormessage: "",
      // lookuptext: "",
      // active: "",
    });
  }
  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    typ: any,
    vl: string,
    flogic = "AND",
    relfieldname: any,
    metaobjectname: any
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createItem(
        name,
        id,
        ftype,
        opt,
        opr,
        typ,
        vl,
        flogic,
        relfieldname,
        metaobjectname
      )
    );
    this.picklistValueList.push([]);
  }
  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }
  loadDefaultDoneList() {
    // var defaultFieldNames = [];
    // var defaultListviewFieldsJSONArray = {};
    // defaultListviewFieldsJSONArray = this.appConfig.defaultListviewFields;

    // var commonFieldNames = [];
    // var commonFieldsJSONArray = {};
    const commonFieldsJSONArray = this.appConfig.COMMON_FIELDS;

    // if (defaultListviewFieldsJSONArray.hasOwnProperty(this.metaobjectName)) {
    //   defaultFieldNames = defaultListviewFieldsJSONArray[this.metaobjectName];
    // } else if (defaultListviewFieldsJSONArray.hasOwnProperty("anyothers")) {
    //   defaultFieldNames = defaultListviewFieldsJSONArray["anyothers"];
    // }

    //console.log("defaulfieldnames", defaultFieldNames);

    console.log("fields", this.fields);

    for (let i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];

      //skip id type fields if there
      if (field.fieldtype.toLowerCase() == "id") continue;

      //skip fields with visibility false
      if (field.visible == false) continue;

      //skip fields deleted, ownertype etc.,
      if (
        field.fieldname.toLowerCase() == "deleted" ||
        field.fieldname.toLowerCase() == "ownertype" ||
        field.fieldname.toLowerCase() == "migrated" ||
        field.fieldname.toLowerCase() == "organizationid"
      )
        continue;

      //skip converted field if object is lead
      if (
        this.metaobjectName.toLowerCase().trim() == "lead" &&
        field.fieldname.toLowerCase() == "converted"
      )
        continue;

      var orgFieldName = field.fieldname;
      var bExistsInDefault = false;

      // for (let j = 0; j < defaultFieldNames.length; j++) {
      //   var doneDefaultFieldName = defaultFieldNames[j];
      //   //console.log("doneFieldName", doneDefaultFieldName);
      //   if (orgFieldName.toLowerCase() == doneDefaultFieldName.toLowerCase()) {
      //     bExistsInDefault = true;
      //     // this.firstfieldsDone.push(field);
      //     break;
      //   }
      // }

      if (!bExistsInDefault) {
        this.firstfieldsToDo.push(field);
      }

      //finally sort the done list as given in the default field name
      var sorted = _.sortBy(
        this.firstfieldsDone,
        function (obj: { fieldname: any }) {
          // return _.indexOf(defaultFieldNames, obj.fieldname);
        }
      );
      //console.log("sorted", sorted);
      this.firstfieldsDone = sorted;
    }

    for (let commonField of commonFieldsJSONArray) {
      let commonFieldName = commonField.fieldname;
      let fieldExistsInDefault =
        this.firstfieldsToDo.some(
          (field) =>
            field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
        ) ||
        this.firstfieldsDone.some(
          (field) =>
            field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
        );

      if (!fieldExistsInDefault) {
        this.firstfieldsToDo.push({ ...commonField });
      }
    }

    //console.log("fieldstodo", this.fieldsToDo);
  }

  loadSecondDefaultDoneList() {
    // var defaultFieldNames = [];
    // var defaultListviewFieldsJSONArray = {};
    // defaultListviewFieldsJSONArray = this.appConfig.defaultListviewFields;

    // // var commonFieldNames = [];
    // // var commonFieldsJSONArray = {};
    // const commonFieldsJSONArray = this.appConfig.COMMON_FIELDS;

    // if (defaultListviewFieldsJSONArray.hasOwnProperty(this.metaobjectName)) {
    //   defaultFieldNames = defaultListviewFieldsJSONArray[this.metaobjectName];
    // } else if (defaultListviewFieldsJSONArray.hasOwnProperty("anyothers")) {
    //   defaultFieldNames = defaultListviewFieldsJSONArray["anyothers"];
    // }

    //console.log("defaulfieldnames", defaultFieldNames);

    for (let i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];

      //skip id type fields if there
      if (field.fieldtype.toLowerCase() == "id") continue;

      //skip fields with visibility false
      if (field.visible == false) continue;

      //skip fields deleted, ownertype etc.,
      if (
        field.fieldname.toLowerCase() == "deleted" ||
        field.fieldname.toLowerCase() == "ownertype" ||
        field.fieldname.toLowerCase() == "migrated" ||
        field.fieldname.toLowerCase() == "organizationid"
      )
        continue;

      //skip converted field if object is lead
      if (
        this.metaobjectName.toLowerCase().trim() == "lead" &&
        field.fieldname.toLowerCase() == "converted"
      )
        continue;

      var orgFieldName = field.fieldname;
      // var bExistsInDefault = false;

      // for (let j = 0; j < defaultFieldNames.length; j++) {
      //   var doneDefaultFieldName = defaultFieldNames[j];
      //   //console.log("doneFieldName", doneDefaultFieldName);
      //   if (orgFieldName.toLowerCase() == doneDefaultFieldName.toLowerCase()) {
      //     bExistsInDefault = true;
      //     // this.firstfieldsDone.push(field);
      //     break;
      //   }
      // }

      // if (!bExistsInDefault) {
      this.secondfieldsToDo.push(field);
      // }

      //finally sort the done list as given in the default field name
      var sorted = _.sortBy(
        this.secondfieldsDone,
        function (obj: { fieldname: any }) {
          // return _.indexOf(defaultFieldNames, obj.fieldname);
        }
      );
      //console.log("sorted", sorted);
      this.firstfieldsDone = sorted;
    }

    //console.log("fieldstodo", this.fieldsToDo);
  }

  loadDefaultButtonDoneList() {
    // const defaultButtonsJSONArray = this.appConfig.defaultButtons;

    // let defaultButtonNames = [];
    // if (defaultButtonsJSONArray.hasOwnProperty(this.metaobjectName)) {
    //   defaultButtonNames = defaultButtonsJSONArray[this.metaobjectName];
    // } else if (defaultButtonsJSONArray.hasOwnProperty("anyothers")) {
    //   defaultButtonNames = defaultButtonsJSONArray["anyothers"];
    // }

    // console.log("defaultButtonNames", defaultButtonNames);

    // Add buttons from defaultButtonNames
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      const orgButtonName = button.name;

      // if (defaultButtonNames.includes(orgButtonName)) {
      //   this.firstbuttonsDone.push(button);
      // } else {
      this.firstbuttonsToDo.push(button);
      // }
    }

    // Add buttons from COMMON_BUTTONS if they don't already exist in buttonsToDo or buttonsDone
    for (let i = 0; i < this.COMMON_BUTTONS.length; i++) {
      const commonButton = this.COMMON_BUTTONS[i];
      const commonButtonName = commonButton.name;

      let buttonExistsInDefault = false;

      // Check if the common button already exists in buttonsToDo or buttonsDone
      for (let j = 0; j < this.firstbuttonsToDo.length; j++) {
        if (
          this.firstbuttonsToDo[j].name.toLowerCase() ===
          commonButtonName.toLowerCase()
        ) {
          buttonExistsInDefault = true;
          break;
        }
      }

      for (let j = 0; j < this.firstbuttonsDone.length; j++) {
        if (
          this.firstbuttonsDone[j].name.toLowerCase() ===
          commonButtonName.toLowerCase()
        ) {
          buttonExistsInDefault = true;
          break;
        }
      }

      // If the common button doesn't exist in either buttonsToDo or buttonsDone, add it to buttonsToDo
      if (!buttonExistsInDefault) {
        this.firstbuttonsToDo.push({ ...commonButton });
      }
    }

    // Sort buttonsDone according to defaultButtonNames
    this.firstbuttonsDone = _.sortBy(
      this.firstbuttonsDone,
      function (obj: { name: any }) {
        // return _.indexOf(defaultButtonNames, obj.name);
      }
    );
  }

  loadsecondDefaultButtonDoneList() {
    // const defaultButtonsJSONArray = this.appConfig.defaultButtons;

    // let defaultButtonNames = [];
    // if (defaultButtonsJSONArray.hasOwnProperty(this.metaobjectName)) {
    //   defaultButtonNames = defaultButtonsJSONArray[this.metaobjectName];
    // } else if (defaultButtonsJSONArray.hasOwnProperty("anyothers")) {
    //   defaultButtonNames = defaultButtonsJSONArray["anyothers"];
    // }

    // console.log("defaultButtonNames", defaultButtonNames);

    // Add buttons from defaultButtonNames
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      const orgButtonName = button.name;

      // if (defaultButtonNames.includes(orgButtonName)) {
      // this.firstbuttonsDone.push(button);
      // } else {
      this.secondbuttonsToDo.push(button);
      // }
    }

    // Sort buttonsDone according to defaultButtonNames
    this.secondbuttonsDone = _.sortBy(
      this.secondbuttonsDone,
      function (obj: { name: any }) {
        // return _.indexOf(defaultButtonNames, obj.name);
      }
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      //console.log("event.previousContainer", event.previousContainer.id);
      //console.log("event.container", event.container.id);
      //console.log("event.previousIndex", event.previousIndex);

      //prevent dragging the name field
      // var fld = event.previousContainer.data[event.previousIndex];
      // if (fld["fieldname"] == "name") return;

      //var fld = JSON.parse(event.previousContainer.data[event.previousIndex]);
      //console.log(fld.fieldname);
      //if(event.previousContainer.data[event.previousIndex].fieldname.)
      /*if(event.previousContainer.id = 'cdk-drop-list-1') //DoneList
      {
        if(this.fieldsDone.length == 1){
          this.showWarning("Selected fields cannot be empty");
          return;           
        }
      }*/

      if (this.firstfieldsDone.length < 11) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
        console.log(this.firstfieldsDone);
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    public dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    //    console.log(document.getElementById("visibleme").getAttribute("checked"));
    //  console.log(document.getElementById("visibleall").getAttribute("checked"));
  }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      if (this.mode.toLocaleLowerCase().trim() == "edit") {
        this.metalayoutId = this.route.snapshot.params.id;
        this.metalayoutName = this.route.snapshot.params.metalayoutname;
        this.displayName = this.route.snapshot.params.displayname;
      }
      this.profileId = this.route.snapshot.params.profileid;
      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.publicaccess == "true";
      this.publicAccess = boolValue;
    });
    console.log("response00000 metalayoutName", this.displayName);

    this.filterForm = this.fb.group({
      metaobjectid: "",
      metaobjectname: "",
      filteritems: this.fb.array([]),
      filterlogic: ""
    });

    this.attributeForm = this.fb.group({
      searchablefield: ""
    });
    //create operator type picklist from operatortypes
    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel
      });
    }

    this.guid = new GUID();

    console.log("mode", this.mode);

    //Check if the profile has customview related permissions
    // if (this.mode.toLocaleLowerCase().trim() == "new") {
    //   //load fields
    //   this.getMetaFieldsForSelection().then((res) => {
    //     console.log("response1111", res);

    //     //load default done list first
    //     this.loadDefaultDoneList();

    //     this.loadSecondDefaultDoneList();

    //     // this.retrieveMetabuttons();

    //     // this.loadDefaultButtonDoneList();

    //     this.addFilterItem("", "", "", [], "", "");
    //     this.addFilterItem("", "", "", [], "", "");
    //     this.addFilterItem("", "", "", [], "", "");

    //     this.isDataLoaded = true;

    //     this.retrieveLookupFields().then((res)=>{

    //     });
    //   }); //getMetaFieldsForSelection()

    //   this.retrieveMetabuttons().then((res) => {
    //     this.loadDefaultButtonDoneList();
    //     this.loadsecondDefaultButtonDoneList();
    //   });
    // }
    if (this.mode.toLocaleLowerCase().trim() == "new") {
      // Load fields

      this.retrieveLookupFields().then(() => {
        setTimeout(() => {
          this.getMetaFieldsForSelection().then((res) => {
            console.log("response1111", res);

            console.log("lookupFieldsRes", this.allFields);
            console.log(this.fields);
            // this.fields = [...this.fields, ...this.allFields];
            // console.log(this.fields);
            // Load default done list first

            if (this.allFields) {
              this.allFields.forEach((field) => {
                this.firstfieldsToDo.push(field);
                this.secondfieldsToDo.push(field);
              });
              this.isDataLoaded = true;
            }
            // This retrieveMetabuttons function call seems related to buttons, not fields
            this.retrieveMetabuttons().then((res) => {
              this.loadDefaultButtonDoneList();
              // this.loadsecondDefaultButtonDoneList();
            });

            // this.addFilterItem("", "", "", [], "", "");
            // this.addFilterItem("", "", "", [], "", "");
            // this.addFilterItem("", "", "", [], "", "");
            this.addFilterItem("", "", "", [], "", "", "", "", "", "");
            this.addFilterItem("", "", "", [], "", "", "", "", "", "");
            this.addFilterItem("", "", "", [], "", "", "", "", "", "");

            this.isDataLoaded = true;

            // Retrieve lookup fields after loading meta fields
            // this.retrieveLookupFields().then(() => {
            //   console.log("lookupFieldsRes", this.allFields);

            //   // Combine the fields from both sources
            //   // this.fields = [...this.fields, ...allFields];

            //   console.log("All fields combined", this.fields);
            // });

            this.loadDefaultDoneList();
            this.loadSecondDefaultDoneList();
          });
        }, 2000);
      }); // getMetaFieldsForSelection()
    } else {
      //load queues
      this.retrieveLookupFields().then(() => {
        setTimeout(() => {
          this.getMetaFieldsForSelection().then((res) => {
            console.log("response1111", res);
            this.retrieveMetabuttons();
            // load metalayout details
            this.getMetaLayoutByName().then((res) => {
              console.log("this.metalayout", this.metalayout);
              // console.log("this.res", res);
              console.log(this.allFields);
              // this.allFields.forEach((field) => {
              //   // this.firstfieldsToDo.push(field);
              //   this.secondfieldsToDo.push(field);
              // });

              //assign metalayout detail data
              this.assignMetalayoutData();

              if (this.filteritems == null) {
                // this.addFilterItem("", "", "", "", "", "");
                // this.addFilterItem("", "", "", "", "", "");
                // this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
              } else if (this.filteritems.length == 1) {
                // this.addFilterItem("", "", "", "", "", "");
                // this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
              } else if (this.filteritems.length == 2) {
                // this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", [], "", "", "", "", "", "");
              }

              this.isDataLoaded = true;

              // this.retrieveLookupFields();
            });
          }); //getMetaLayoutByName()
        }, 2000);
      });
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  aliasdialog(field: any): void {
    console.log("field", field);
    var fieldName = field.fieldname;

    // Reset the form and clear previous data
    this.aliasForm = this.fb.group({
      aliasname: ""
    });

    let sectionData = this.fields.find((f) => f.fieldname === fieldName);
    if (!sectionData) {
      sectionData = this.allFields.find((f) => f.fieldname === fieldName);
    }
    if (sectionData && sectionData.aliasname) {
      this.aliasForm.patchValue({ aliasname: sectionData.aliasname });
    }
    // if (sectionData) {
    //   sectionData.translategroup.forEach((group) => {
    //     const translateSectionGroup = this.fb.group({
    //       languageCode: [group.languageCode, Validators.required],
    //       translatedName: [group.translatedName, Validators.required],
    //     });
    //     this.translategroup.push(translateSectionGroup);
    //   });
    // }
    // console.log(sectionData);
    this.data = { aliasname: sectionData.aliasname || "" };

    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.aliasDialog, {
      data: this.data,
      height: "280px",
      width: "400px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      console.log("The dialog was closed with result:", result);

      if (result) {
        field.aliasname = this.aliasForm.controls["aliasname"].value;
        console.log("Updated field", field);
        console.log("Updated field", field);

        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
      }
    });
  }

  ok(): void {
    // this.dialogRef.close(this.data);
    this.dialogRef.close({
      aliasname: this.aliasForm.controls["aliasname"].value
    });

    console.log(this.data);
    console.log(this.detailForm);
  }

  close() {
    this.dialogRef.close();
  }

  getMetaLayoutByName() {
    return new Promise((resolve, reject) => {
      console.log("getMetaLayoutByName");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metalayout: {
            name: this.metalayoutName,
            id: this.metalayoutId
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetalayoutByName(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metalayout = res.data.metalayout;
            this.metaProfileLayouts = res.data.metalayout.metaprofilelayouts;
            this.metaProfileLayoutWebs =
              res.data.metalayout.metaprofilelayoutwebs;
            this.modifiedby = this.metalayout.modifiedby;
            this.modifieddate = this.metalayout.modifieddate;
            this.isLoading = false;
            console.log("metalayout!!!!", this.metalayout);
            resolve(null);
          } else {
            console.log("No metalayout data");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            // Add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: ""
            });

            // Helper function to add fields to fieldList
            const addFieldsToFieldList = (fields: any[]) => {
              for (let i = 0; i < fields.length; i++) {
                var field = fields[i];

                // Skip id type fields
                if (field.fieldtype.toLowerCase() === "id") continue;

                // Skip fields with visibility false
                if (field.visible === false) continue;

                // Skip fields like deleted, ownertype, etc.
                if (
                  field.fieldname.toLowerCase() === "deleted" ||
                  field.fieldname.toLowerCase() === "ownertype" ||
                  field.fieldname.toLowerCase() === "migrated" ||
                  field.fieldname.toLowerCase() === "organizationid"
                )
                  continue;

                // Skip converted field if object is lead
                if (
                  this.metaobjectName.toLowerCase().trim() === "lead" &&
                  field.fieldname.toLowerCase() === "converted"
                )
                  continue;

                // // Convert label to title case
                // var strLabel = field.labelname;
                // strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);

                // // Add field to fieldList
                // this.fieldList.push({
                //   value: field.fieldname,
                //   label: strLabel,
                //   fieldtype: field.fieldtype,
                //   standard: field.standard,
                //   options: field.options,
                //   id: field.id,
                //   relatedfieldname: field.relatedfieldname || null, // Include relatedfieldname for lookup fields
                // });

                //convert to titecase
                var strLabel = field.labelname;
                var formattedLabel = field.metaobjectname + ": " + strLabel;

                strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
                this.fieldList.push({
                  // value: field.fieldname,
                  value: field.id,
                  fieldname: field.fieldname,
                  label: formattedLabel,
                  fieldtype: field.fieldtype,
                  standard: field.standard,
                  options: field.options,
                  metaobjectname: field.metaobjectname,
                  relatedfieldname: field.relatedfieldname,

                  // id: field.id,
                  id: field.fieldname
                });
              }
            };

            // Add fields from this.fields
            addFieldsToFieldList(this.fields);

            console.log("allFields", this.allFields);

            // Add fields from this.allFields (lookup fields)
            if (this.allFields && Array.isArray(this.allFields)) {
              addFieldsToFieldList(this.allFields);
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  // getMetaFieldsForSelection() {
  //   return new Promise((resolve, reject) => {
  //     console.log("getMetaFieldsForSelection");

  //     var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

  //     let postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       userid: localStorage.getItem("crm_userid"),
  //       username: localStorage.getItem("crm_username"),
  //       // domain: localStorage.getItem("domain"),
  //       // subdomain: localStorage.getItem("subdomain"),
  //       domain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.domain`
  //       ),
  //       subdomain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.subdomain`
  //       ),
  //       profileid: userDetail.profileid,
  //       data: {
  //         metafield: {
  //           metaobjectid: this.metaobjectId,
  //           metaobjectname: this.metaobjectName,
  //         },
  //       },
  //     };

  //     console.log("postOption", postOption);

  //     this.isLoading = true;
  //     this.dataService.getMetaFieldsForSelection(postOption).subscribe(
  //       (res) => {
  //         console.log(res);
  //         if (res !== null && res.success == 1) {
  //           this.fields = res.data.metafields;

  //           //add default --None-- into field list
  //           this.fieldList.push({
  //             value: "--None--",
  //             label: "--None--",
  //             fieldtype: "text",
  //             standard: true,
  //             options: [],
  //             id: "",
  //           });

  //           //create fieldlist from fields as readable form by selection control
  //           for (let i = 0; i < this.fields.length; i++) {
  //             var field = this.fields[i];

  //             //skip id type fields if there
  //             if (field.fieldtype.toLowerCase() == "id") continue;

  //             //skip fields with visibility false
  //             if (field.visible == false) continue;

  //             //skip fields deleted, ownertype etc.,
  //             if (
  //               field.fieldname.toLowerCase() == "deleted" ||
  //               field.fieldname.toLowerCase() == "ownertype" ||
  //               field.fieldname.toLowerCase() == "migrated" ||
  //               field.fieldname.toLowerCase() == "organizationid"
  //             )
  //               continue;

  //             //skip converted field if object is lead
  //             if (
  //               this.metaobjectName.toLowerCase().trim() == "lead" &&
  //               field.fieldname.toLowerCase() == "converted"
  //             )
  //               continue;

  //             //convert to titecase
  //             var strLabel = field.labelname;

  //             strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
  //             this.fieldList.push({
  //               value: field.fieldname,
  //               label: strLabel,
  //               fieldtype: field.fieldtype,
  //               standard: field.standard,
  //               options: field.options,
  //               id: field.id,
  //             });
  //           }

  //           this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("No fields data!");
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            fieldtype: "lookup"
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getObjectLookupFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.metaobjectList = res.metaobject;
            console.log(this.metaobjectList);
            if (this.metaobjectList) {
              // Loop through the metaobjectList and call getMetaFieldsForSelection
              const promises = this.metaobjectList.map((metaobject) => {
                return this.getObjectLookupFieldsForFieldsList(
                  metaobject.relatedobjectid,
                  metaobject.relatedto,
                  metaobject.metafieldname
                );
              });

              Promise.all(promises)
                .then((results) => {
                  console.log("Promise.all results:", results);

                  // const allFields = [];

                  // Iterate through each result (fields array) and concatenate into allFields
                  // results.forEach((fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     allFields.push(...fields);
                  //   }
                  //   return allFields
                  // });
                  // const allFields = results.reduce((acc, fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     acc.push(...fields);
                  //   }
                  //   return acc;
                  // }, []);
                  const allFields = results.reduce((acc: any[], fields) => {
                    if (fields && Array.isArray(fields)) {
                      acc.push(...fields);
                    }
                    return acc;
                  }, []);

                  this.allFields = allFields;

                  console.log("Combined lookup fields", this.allFields);

                  this.isLoading = false;
                  resolve(null); // Resolve with the combined fields
                })
                .catch((err) => {
                  console.log("Error***:", err);
                  this.errorMessage = err.message;
                  this.isError = true;
                  this.isLoading = false;
                  resolve(null);
                });
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        }
      );
    });
  }

  getObjectLookupFieldsForFieldsList(
    metaobjectid: any,
    metaobjectname: any,
    metafieldname: any
  ) {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: metaobjectid,
            metaobjectname: metaobjectname
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            const fields = res.data.metafields;

            // Filter and transform fields before adding them to the fieldList
            fields.forEach((field: any) => {
              field.relatedfieldname = metafieldname;
              if (
                field.fieldtype.toLowerCase() !== "id" &&
                field.visible !== false &&
                ![
                  "deleted",
                  "ownertype",
                  "migrated",
                  "organizationid"
                ].includes(field.fieldname.toLowerCase()) &&
                !(
                  this.metaobjectName.toLowerCase().trim() === "lead" &&
                  field.fieldname.toLowerCase() === "converted"
                )
              ) {
                let strLabel = field.labelname;
                strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              }
            });

            this.isLoading = false;
            resolve(fields);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  //   retrieveLookupFields() {
  //     return new Promise((resolve, reject) => {
  //         console.log("LookupFields");

  //         let postOption = {
  //             organizationid: localStorage.getItem("crm_orgid"),
  //             userid: localStorage.getItem("crm_userid"),
  //             username: localStorage.getItem("crm_username"),
  //             domain: localStorage.getItem(
  //                 `${localStorage.getItem("crm_orgid")}.domain`
  //             ),
  //             subdomain: localStorage.getItem(
  //                 `${localStorage.getItem("crm_orgid")}.subdomain`
  //             ),
  //             data: {
  //                 metafield: {
  //                     metaobjectid: this.metaobjectId,
  //                     metaobjectname: this.metaobjectName,
  //                     fieldtype: "lookup",
  //                 },
  //             },
  //         };
  //         console.log("postOption", postOption);
  //         this.isLoading = true;
  //         this.dataService.getObjectLookupFields(postOption).subscribe(
  //             (res) => {
  //                 console.log("res", res);

  //                 if (res !== null && res.success == 1) {
  //                     this.metaobjectList = res.metaobject;
  //                     console.log(this.metaobjectList);

  //                     // Loop through the metaobjectList and call getObjectLookupFieldsForFieldsList
  //                     const promises = this.metaobjectList.map((metaobject) => {
  //                         return this.getObjectLookupFieldsForFieldsList(
  //                             metaobject.relatedobjectid,
  //                             metaobject.relatedto
  //                         );
  //                     });

  //                     Promise.all(promises)
  //                         .then((results) => {
  //                             results.forEach(fields => {
  //                                 this.fields.push(...fields);
  //                             });
  //                             console.log(this.fields);
  //                             this.isLoading = false;
  //                             resolve(null);
  //                         })
  //                         .catch((err) => {
  //                             console.log("Error***:", err);
  //                             this.errorMessage = err.message;
  //                             this.isError = true;
  //                             this.isLoading = false;
  //                             resolve(null);
  //                         });

  //                     this.isLoading = false;
  //                     resolve(null);
  //                 } else {
  //                     console.log("No metaobject data!");
  //                     this.errorMessage =
  //                         res != null ? res.message : "No metaobject data!";
  //                     this.isError = true;
  //                     this.isLoading = false;
  //                     resolve(null);
  //                 }
  //             },
  //             (err) => {
  //                 console.log("Error***:", err);
  //                 this.errorMessage = err.message;
  //                 this.isError = true;
  //                 this.isLoading = false;
  //                 resolve(null);
  //             }
  //         );
  //     });
  // }

  // // Adjusted getObjectLookupFieldsForFieldsList to resolve only after processing
  // getObjectLookupFieldsForFieldsList(metaobjectid, metaobjectname) {
  //     return new Promise((resolve, reject) => {
  //         console.log("getMetaFieldsForSelection");

  //         var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

  //         let postOption = {
  //             organizationid: localStorage.getItem("crm_orgid"),
  //             userid: localStorage.getItem("crm_userid"),
  //             username: localStorage.getItem("crm_username"),
  //             domain: localStorage.getItem(
  //                 `${localStorage.getItem("crm_orgid")}.domain`
  //             ),
  //             subdomain: localStorage.getItem(
  //                 `${localStorage.getItem("crm_orgid")}.subdomain`
  //             ),
  //             profileid: userDetail.profileid,
  //             data: {
  //                 metafield: {
  //                     metaobjectid: metaobjectid,
  //                     metaobjectname: metaobjectname,
  //                 },
  //             },
  //         };

  //         console.log("postOption", postOption);

  //         this.isLoading = true;
  //         this.dataService.getMetaFieldsForSelection(postOption).subscribe(
  //             (res) => {
  //                 console.log(res);
  //                 if (res !== null && res.success == 1) {
  //                     let fieldsToAdd = res.data.metafields;
  //                     let filteredFields = [];

  //                     // Filter and transform fields before adding them to the fieldList
  //                     fieldsToAdd.forEach((field) => {
  //                         if (
  //                             field.fieldtype.toLowerCase() !== "id" &&
  //                             field.visible !== false &&
  //                             ![
  //                                 "deleted",
  //                                 "ownertype",
  //                                 "migrated",
  //                                 "organizationid",
  //                             ].includes(field.fieldname.toLowerCase()) &&
  //                             !(
  //                                 this.metaobjectName.toLowerCase().trim() === "lead" &&
  //                                 field.fieldname.toLowerCase() === "converted"
  //                             )
  //                         ) {
  //                             let strLabel = field.labelname;
  //                             strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
  //                             filteredFields.push({
  //                                 value: field.fieldname,
  //                                 label: strLabel,
  //                                 fieldtype: field.fieldtype,
  //                                 standard: field.standard,
  //                                 options: field.options,
  //                                 id: field.id,
  //                             });
  //                         }
  //                     });

  //                     this.isLoading = false;
  //                     resolve(filteredFields);
  //                 } else {
  //                     console.log("No fields data!");
  //                     this.isLoading = false;
  //                     resolve([]);
  //                 }
  //             },
  //             (err) => {
  //                 console.log("Error***:", err);
  //                 this.errorMessage = err.message;
  //                 this.isError = true;
  //                 this.isLoading = false;
  //                 resolve([]);
  //             }
  //         );
  //     });
  // }

  assignMetalayoutData() {
    if (this.metalayout != null) {
      this.metalayoutId = this.metalayout.id;
      this.metalayoutName = this.metalayout.name;

      // this.metaProfileLayoutId = this.metalayout.metaprofilelayouts[0].id;
      this.metaLayoutGroupId = this.metalayout.metalayoutgroups[0].id;
      // this.metaProfileLayoutWebId = this.metalayout.metaprofilelayoutwebs[0].id;

      this.attributeForm.controls["searchablefield"].setValue(
        this.metalayout.attributes.searchablefield
      );
      //detailform
      this.detailForm.controls["metaobjectid"].setValue(
        this.metalayout.metaobjectid
      );
      this.detailForm.controls["metaobjectname"].setValue(
        this.metalayout.metaobjectname
      );
      this.detailForm.controls["layouttype"].setValue(this.metalayout.action);

      this.detailForm.controls["id"].setValue(this.metalayout.id);
      this.detailForm.controls["displayname"].setValue(
        this.metalayout.displayname
      );
      this.detailForm.controls["viewname"].setValue(this.metalayout.viewname);
      this.detailForm.controls["name"].setValue(this.metalayout.name);
      this.detailForm.controls["publicaccess"].setValue(
        this.metalayout.publicaccess
      );
      if (this.metalayout.publicaccess == true) {
        this.visibleAllChecked = true;
        this.visibleMeChecked = false;
      } else {
        this.visibleMeChecked = true;
        this.visibleAllChecked = false;
      }

      this.detailForm.controls["active"].setValue(this.metalayout.active);
      this.detailForm.controls["attributes"].setValue(
        this.metalayout.attributes
      );

      this.detailForm.controls["targeturl"].setValue(this.metalayout.targeturl);
      this.detailForm.controls["columncount"].setValue(
        this.metalayout.columncount
      );
      this.detailForm.controls["tabkeyorder"].setValue(
        this.metalayout.tabkeyorder
      );
      this.detailForm.controls["hascustomview"].setValue(
        this.metalayout.hascustomview
      );
      this.detailForm.controls["clonable"].setValue(this.metalayout.clonable);
      this.detailForm.controls["editable"].setValue(this.metalayout.editable);
      this.detailForm.controls["deletable"].setValue(this.metalayout.deletable);
      this.detailForm.controls["haskanbanview"].setValue(
        this.metalayout.haskanbanview
      );
      this.detailForm.controls["searchtext"].setValue(
        this.metalayout.searchtext
      );
      this.detailForm.controls["sortby"].setValue(this.metalayout.sortby);
      this.detailForm.controls["sortorder"].setValue(this.metalayout.sortorder);
      this.detailForm.controls["sinceversionseq"].setValue(
        this.metalayout.sinceversionseq != null
          ? this.metalayout.sinceversionseq
          : 0
      );
      this.detailForm.controls["deprecatedversionseq"].setValue(
        this.metalayout.deprecatedversionseq != null
          ? this.metalayout.deprecatedversionseq
          : 0
      );
      this.detailForm.controls["category"].setValue(this.metalayout.category);
      this.detailForm.controls["devicetype"].setValue(
        this.metalayout.devicetype
      );

      if (this.metalayout.metaprofilelayoutcriterias.length > 0) {
        this.filterForm.controls["filterlogic"].setValue(
          this.metalayout.metaprofilelayoutcriterias[0].filterlogic
        );
      }

      //filterform

      var criterias = this.metalayout.metaprofilelayoutcriterias;
      var index = 0;
      for (let i = 0; i < criterias.length; i++) {
        // this.filterForm.controls["filterlogic"].setValue(
        //   criteria.filterlogic
        // );
        var criteria = criterias[i];

        console.log("criteria", criteria);
        //skip id type fields if there
        if (criteria.metafieldname.toLowerCase() == "deleted") {
          console.log("deleted found.");
          continue;
        }
        //skip converted field if object is lead
        if (
          this.metaobjectName.toLowerCase().trim() == "lead" &&
          criteria.metafieldname.toLowerCase() == "converted"
        ) {
          console.log("converted found.");
          continue;
        }

        // //get addnl field detail from fields
        // var fldName = "";
        // var fldLabel = "";
        // var fldType = "";
        // var fldOptions: string;

        // for (let j = 0; j < this.fields.length; j++) {
        //   if (this.fields[j].id == criteria.metafieldid) {
        //     fldName = this.fields[j].fieldname;
        //     //convert to titecase
        //     fldLabel = this.fields[j].labelname;
        //     fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
        //     fldType = this.fields[j].fieldtype;

        //     if (this.fields[j].options != null) {
        //       fldOptions = this.fields[j].options;
        //     }
        //     //console.log("fldOptions", fldOptions);
        //     break;
        //   }
        // }

        // if (fldType == "checkbox") {
        //   criteria.fieldvalue = JSON.parse(criteria.fieldvalue);
        // }

        // //add item
        // console.log("criteria.value", criteria);
        // this.addFilterItem(
        //   criteria.metafieldid,
        //   fldName,
        //   fldType,
        //   fldOptions,
        //   criteria.fieldoperator,
        //   criteria.fieldvalue,
        //   criteria.filterlogic
        // );

        //get addnl field detail from fields
        var fldName = "";
        var fldLabel = "";
        var fldType = "";
        var fldOptions: string;
        var fldId = "";
        var relFieldName = "";
        var objName = "";

        // console.log(this.allFields);
        console.log(this.fieldList);

        for (let j = 0; j < this.fieldList.length; j++) {
          if (this.fieldList[j].value == criteria.metafieldid) {
            console.log(this.fieldList[j].id);
            fldName = this.fieldList[j].fieldname;
            fldId = this.fieldList[j].value;
            //convert to titecase
            fldLabel = this.fieldList[j].label;
            fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
            fldType = this.fieldList[j].fieldtype;
            relFieldName = this.fieldList[j].relatedfieldname;
            objName = this.fieldList[j].metaobjectname;

            if (this.fieldList[j].options != null) {
              fldOptions = this.fieldList[j].options;
            }
            //console.log("fldOptions", fldOptions);
            break;
          }
        }

        //add item
        console.log("criteria", criteria);
        const value =
          fldType === "checkbox"
            ? Boolean(criteria.fieldvalue)
            : criteria.fieldvalue;

        this.addFilterItem(
          // criteria.fieldid,
          fldId,
          fldName,
          fldType,
          fldOptions,
          criteria.fieldoperator,
          criteria.type,
          // criteria.value
          value,
          "1",
          // criteria.relatedfieldname,
          relFieldName,
          // criteria.metaobjectname
          objName
        );
        if (fldOptions != null) {
          var arr = JSON.parse(fldOptions);
          this.picklistValueList[index] = arr;
        }

        index++;
      }

      // //load fieldtodo and done
      // var metaLayoutGroupFields = this.metalayout.metalayoutgroupfields;
      // if (metaLayoutGroupFields.length > 0) {
      //   //collect fieldnames for sorting
      //   var groupFieldNames = [];
      //   for (let j = 0; j < metaLayoutGroupFields.length; j++) {
      //     groupFieldNames.push(metaLayoutGroupFields[j].fieldname);
      //   }

      //   for (let i = 0; i < this.fields.length; i++) {
      //     var field = this.fields[i];

      //     //skip id type fields if there
      //     if (field.fieldtype.toLowerCase() == "id") continue;

      //     //skip fields with visibility false
      //     if (field.visible == false) continue;

      //     //skip fields deleted, ownertype etc.,
      //     if (
      //       field.fieldname.toLowerCase() == "deleted" ||
      //       field.fieldname.toLowerCase() == "ownertype" ||
      //       field.fieldname.toLowerCase() == "migrated" ||
      //       field.fieldname.toLowerCase() == "organizationid"
      //     )
      //       continue;

      //     //skip converted field if object is lead
      //     if (
      //       this.metaobjectName.toLowerCase().trim() == "lead" &&
      //       field.fieldname.toLowerCase() == "converted"
      //     )
      //       continue;

      //     var orgFieldName = field.fieldname;
      //     var bExistsInDefault = false;

      //     for (let j = 0; j < metaLayoutGroupFields.length; j++) {
      //       //console.log("metaLayoutGroupFields[j]", metaLayoutGroupFields[j]);
      //       var doneFieldName = metaLayoutGroupFields[j].fieldname;
      //       // console.log(doneFieldName)
      //       var metagroupname = metaLayoutGroupFields[j].metagroupname;
      //       //console.log("index j", j);
      //       // console.log("doneFieldName", orgFieldName);
      //       if (doneFieldName.toLowerCase() == "id") continue;

      //       if (orgFieldName.toLowerCase() == doneFieldName.toLowerCase()) {
      //         // bExistsInDefault = true;
      //         // this.firstfieldsDone.push(field);
      //         if (metagroupname.toLowerCase() === "header") {
      //           this.firstfieldsDone.push(field);
      //           console.log(this.firstfieldsDone);
      //         } else if (metagroupname.toLowerCase() === "footer") {
      //           this.secondfieldsDone.push(field);
      //         }

      //         // break;
      //       }
      //     }

      //     if (!bExistsInDefault) {
      //       // Assuming this.allFields is an array
      //       // this.allFields.forEach(field => {
      //       //   this.firstfieldsToDo.push(field);
      //       // });
      //       this.firstfieldsToDo.push(field);
      //       // this.firstfieldsToDo = [...this.firstfieldsToDo, ...this.allFields];
      //       this.secondfieldsToDo.push(field);
      //       // if (metagroupname.toLowerCase() === "header") {
      //       //   this.firstfieldsToDo.push(field);
      //       // }
      //       // if (metagroupname.toLowerCase() === "footer") {
      //       //   this.secondfieldsToDo.push(field);
      //       // }

      //       const commonFieldsJSONArray = this.appConfig.COMMON_FIELDS;

      //       for (let commonField of commonFieldsJSONArray) {
      //         let commonFieldName = commonField.fieldname;
      //         let fieldExistsInDefault =
      //           this.firstfieldsToDo.some(
      //             (field) =>
      //               field.fieldname.toLowerCase() ==
      //               commonFieldName.toLowerCase()
      //           ) ||
      //           this.firstfieldsDone.some(
      //             (field) =>
      //               field.fieldname.toLowerCase() ==
      //               commonFieldName.toLowerCase()
      //           );

      //         if (!fieldExistsInDefault) {
      //           this.firstfieldsToDo.push({ ...commonField });
      //         }
      //       }
      //     }
      //   }

      //   //finally sort the done list as given in the default field name
      //   var sorted = _.sortBy(
      //     this.firstfieldsDone,
      //     function (obj: { fieldname: any }) {
      //       return _.indexOf(groupFieldNames, obj.fieldname);
      //     }
      //   );
      //   //console.log("sorted", sorted);
      //   this.firstfieldsDone = sorted;

      //   var sorted = _.sortBy(
      //     this.secondfieldsDone,
      //     function (obj: { fieldname: any }) {
      //       return _.indexOf(groupFieldNames, obj.fieldname);
      //     }
      //   );
      //   console.log("sorted", sorted);
      //   this.secondfieldsDone = sorted;
      // }

      var metaLayoutGroupFields = this.metalayout.metalayoutgroupfields;
      if (metaLayoutGroupFields.length > 0) {
        // Collect field names for sorting
        var groupFieldNames = [];
        for (let j = 0; j < metaLayoutGroupFields.length; j++) {
          groupFieldNames.push(metaLayoutGroupFields[j].fieldname);
        }

        console.log(this.fields);
        console.log(metaLayoutGroupFields);
        // Process this.fields array
        for (let i = 0; i < this.fields.length; i++) {
          var field = this.fields[i];

          // Skip id type fields if there
          if (field.fieldtype.toLowerCase() == "id") continue;

          // Skip fields with visibility false
          if (field.visible == false) continue;

          // Skip fields deleted, ownertype etc.
          if (
            field.fieldname.toLowerCase() == "deleted" ||
            field.fieldname.toLowerCase() == "ownertype" ||
            field.fieldname.toLowerCase() == "migrated" ||
            field.fieldname.toLowerCase() == "organizationid"
          )
            continue;

          // Skip converted field if object is lead
          if (
            this.metaobjectName.toLowerCase().trim() == "lead" &&
            field.fieldname.toLowerCase() == "converted"
          )
            continue;

          var orgFieldName = field.fieldname;
          var fieldId = field.id;
          var bExistsInDefault = false;

          for (let j = 0; j < metaLayoutGroupFields.length; j++) {
            var doneFieldName = metaLayoutGroupFields[j].fieldname;
            var doneFieldId = metaLayoutGroupFields[j].metafieldid;
            var metagroupname = metaLayoutGroupFields[j].metagroupname;

            if (doneFieldName.toLowerCase() == "id") continue;

            var aliasname = metaLayoutGroupFields[j].aliasname;
            if (
              orgFieldName.toLowerCase() == doneFieldName.toLowerCase() &&
              fieldId == doneFieldId
            ) {
              field.aliasname = aliasname;

              bExistsInDefault = true;
              if (metagroupname.toLowerCase() === "header") {
                this.firstfieldsDone.push(field);
                console.log(this.firstfieldsDone);
              } else if (metagroupname.toLowerCase() === "footer") {
                this.secondfieldsDone.push(field);
              }
            }
          }

          // if (!bExistsInDefault) {
          this.firstfieldsToDo.push(field);
          this.secondfieldsToDo.push(field);
          // }
        }

        const commonFieldsJSONArray = this.appConfig.COMMON_FIELDS;
        for (let commonField of commonFieldsJSONArray) {
          let commonFieldName = commonField.fieldname;
          let fieldExistsInDefault =
            this.firstfieldsToDo.some(
              (field) =>
                field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
            ) ||
            this.firstfieldsDone.some(
              (field) =>
                field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
            );

          if (!fieldExistsInDefault) {
            this.firstfieldsToDo.push({ ...commonField });
          }
        }

        // Process this.allFields array for footer section
        let addedToFirstfieldsDone = new Set();
        let addedToSecondfieldsDone = new Set();
        if (this.allFields) {
          for (let i = 0; i < this.allFields.length; i++) {
            var field = this.allFields[i];

            // Skip id type fields if there
            if (field.fieldtype.toLowerCase() == "id") continue;

            // Skip fields with visibility false
            if (field.visible == false) continue;

            // Skip fields deleted, ownertype etc.
            if (
              field.fieldname.toLowerCase() == "deleted" ||
              field.fieldname.toLowerCase() == "ownertype" ||
              field.fieldname.toLowerCase() == "migrated" ||
              field.fieldname.toLowerCase() == "organizationid"
            )
              continue;

            // Skip converted field if object is lead
            if (
              this.metaobjectName.toLowerCase().trim() == "lead" &&
              field.fieldname.toLowerCase() == "converted"
            )
              continue;

            var orgFieldName = field.fieldname;
            var fieldId = field.id;
            var bExistsInDefault = false;

            for (let j = 0; j < metaLayoutGroupFields.length; j++) {
              var doneFieldName = metaLayoutGroupFields[j].fieldname;
              var doneFieldId = metaLayoutGroupFields[j].metafieldid;
              var metagroupname = metaLayoutGroupFields[j].metagroupname;

              if (doneFieldName.toLowerCase() == "id") continue;
              var aliasname = metaLayoutGroupFields[j].aliasname;

              if (
                orgFieldName.toLowerCase() == doneFieldName.toLowerCase() &&
                fieldId == doneFieldId
              ) {
                field.aliasname = aliasname;
                bExistsInDefault = true;
                if (
                  metagroupname.toLowerCase() === "footer" &&
                  !addedToSecondfieldsDone.has(fieldId)
                ) {
                  // this.secondfieldsDone.push(field);
                  if (!this.secondfieldsDone.some((f) => f.id === field.id)) {
                    this.secondfieldsDone.push(field);
                  }

                  addedToSecondfieldsDone.add(fieldId);
                }
                if (
                  metagroupname.toLowerCase() === "header" &&
                  !addedToFirstfieldsDone.has(fieldId)
                ) {
                  // this.firstfieldsDone.push(field);
                  if (!this.firstfieldsDone.some((f) => f.id === field.id)) {
                    this.firstfieldsDone.push(field);
                  }

                  addedToFirstfieldsDone.add(fieldId);
                }
              }
            }

            // if (!bExistsInDefault) {
            this.firstfieldsToDo.push(field);
            this.secondfieldsToDo.push(field);
            // }
          }
        }

        // Finally sort the done lists as given in the default field name
        var sorted = _.sortBy(this.firstfieldsDone, function (obj) {
          return _.indexOf(groupFieldNames, obj.fieldname);
        });
        this.firstfieldsDone = sorted;

        sorted = _.sortBy(this.secondfieldsDone, function (obj) {
          return _.indexOf(groupFieldNames, obj.fieldname);
        });
        this.secondfieldsDone = sorted;
      }

      // var metaLayoutGroupFields = this.metalayout.metalayoutgroupfields;
      // if (metaLayoutGroupFields.length > 0) {
      //   // Collect field names for sorting
      //   var groupFieldNames = [];
      //   for (let j = 0; j < metaLayoutGroupFields.length; j++) {
      //     groupFieldNames.push(metaLayoutGroupFields[j].fieldname);
      //   }

      //   // Process this.fields array
      //   for (let i = 0; i < this.fields.length; i++) {
      //     var field = this.fields[i];

      //     // Skip id type fields if there
      //     if (field.fieldtype.toLowerCase() == "id") continue;

      //     // Skip fields with visibility false
      //     if (field.visible == false) continue;

      //     // Skip fields deleted, ownertype etc.
      //     if (
      //       field.fieldname.toLowerCase() == "deleted" ||
      //       field.fieldname.toLowerCase() == "ownertype" ||
      //       field.fieldname.toLowerCase() == "migrated" ||
      //       field.fieldname.toLowerCase() == "organizationid"
      //     )
      //       continue;

      //     // Skip converted field if object is lead
      //     if (
      //       this.metaobjectName.toLowerCase().trim() == "lead" &&
      //       field.fieldname.toLowerCase() == "converted"
      //     )
      //       continue;

      //     var orgFieldName = field.fieldname;
      //     var bExistsInDefault = false;

      //     for (let j = 0; j < metaLayoutGroupFields.length; j++) {
      //       var doneFieldName = metaLayoutGroupFields[j].fieldname;
      //       var metagroupname = metaLayoutGroupFields[j].metagroupname;

      //       if (doneFieldName.toLowerCase() == "id") continue;

      //       if (orgFieldName.toLowerCase() == doneFieldName.toLowerCase()) {
      //         bExistsInDefault = true;
      //         if (metagroupname.toLowerCase() === "header") {
      //           this.firstfieldsDone.push(field);
      //         } else if (metagroupname.toLowerCase() === "footer") {
      //           if (!this.secondfieldsDone.some(f => f.fieldname.toLowerCase() === field.fieldname.toLowerCase())) {
      //             this.secondfieldsDone.push(field);
      //           }
      //         }
      //       }
      //     }

      //     if (!bExistsInDefault) {
      //       this.firstfieldsToDo.push(field);
      //       this.secondfieldsToDo.push(field);
      //     }
      //   }

      //   const commonFieldsJSONArray = this.appConfig.COMMON_FIELDS;
      //   for (let commonField of commonFieldsJSONArray) {
      //     let commonFieldName = commonField.fieldname;
      //     let fieldExistsInDefault =
      //       this.firstfieldsToDo.some(
      //         (field) =>
      //           field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
      //       ) ||
      //       this.firstfieldsDone.some(
      //         (field) =>
      //           field.fieldname.toLowerCase() == commonFieldName.toLowerCase()
      //       );

      //     if (!fieldExistsInDefault) {
      //       this.firstfieldsToDo.push({ ...commonField });
      //     }
      //   }

      //   // Process this.allFields array for footer section
      //   let addedToSecondfieldsDone = new Set();
      //   for (let i = 0; i < this.allFields.length; i++) {
      //     var field = this.allFields[i];

      //     // Skip id type fields if there
      //     if (field.fieldtype.toLowerCase() == "id") continue;

      //     // Skip fields with visibility false
      //     if (field.visible == false) continue;

      //     // Skip fields deleted, ownertype etc.
      //     if (
      //       field.fieldname.toLowerCase() == "deleted" ||
      //       field.fieldname.toLowerCase() == "ownertype" ||
      //       field.fieldname.toLowerCase() == "migrated" ||
      //       field.fieldname.toLowerCase() == "organizationid"
      //     )
      //       continue;

      //     // Skip converted field if object is lead
      //     if (
      //       this.metaobjectName.toLowerCase().trim() == "lead" &&
      //       field.fieldname.toLowerCase() == "converted"
      //     )
      //       continue;

      //     var orgFieldName = field.fieldname;
      //     var bExistsInDefault = false;

      //     for (let j = 0; j < metaLayoutGroupFields.length; j++) {
      //       var doneFieldName = metaLayoutGroupFields[j].fieldname;
      //       var metagroupname = metaLayoutGroupFields[j].metagroupname;

      //       if (doneFieldName.toLowerCase() == "id") continue;

      //       if (orgFieldName.toLowerCase() == doneFieldName.toLowerCase()) {
      //         bExistsInDefault = true;
      //         if (metagroupname.toLowerCase() === "footer" && !addedToSecondfieldsDone.has(orgFieldName)) {
      //           this.secondfieldsDone.push(field);
      //           addedToSecondfieldsDone.add(orgFieldName);
      //         }
      //       }
      //     }

      //     if (!bExistsInDefault) {
      //       this.secondfieldsToDo.push(field);
      //     }
      //   }

      //   // Finally sort the done lists as given in the default field name
      //   var sorted = _.sortBy(
      //     this.firstfieldsDone,
      //     function (obj) {
      //       return _.indexOf(groupFieldNames, obj.fieldname);
      //     }
      //   );
      //   this.firstfieldsDone = sorted;

      //   sorted = _.sortBy(
      //     this.secondfieldsDone,
      //     function (obj) {
      //       return _.indexOf(groupFieldNames, obj.fieldname);
      //     }
      //   );
      //   this.secondfieldsDone = sorted;
      // }

      console.log(this.firstfieldsDone);

      console.log(this.secondfieldsDone);

      var metaLayoutButtons = this.metalayout.metalayoutbuttons;
      console.log("metaLayoutButtons", metaLayoutButtons);

      if (metaLayoutButtons.length > 0) {
        console.log("Hello");
        //collect fieldnames for sorting
        var buttonNames = [];
        for (let j = 0; j < metaLayoutButtons.length; j++) {
          buttonNames.push(metaLayoutButtons[j].name);
        }

        for (let i = 0; i < this.buttons.length; i++) {
          console.log("hello12345");
          console.log("this.buttons[i]", this.buttons[i]);
          var button = this.buttons[i];

          var orgButtonName = button.name;
          var orgButtonLabel = button.labelname;

          var bExistsInDefault = false;
          for (let j = 0; j < metaLayoutButtons.length; j++) {
            //console.log("metaLayoutGroupFields[j]", metaLayoutGroupFields[j]);
            var donebuttonName = metaLayoutButtons[j].name;
            var donebuttonLabel = metaLayoutButtons[j].labelname;

            var donebuttonActionType = metaLayoutButtons[j].actiontype;

            // var metagroupname = metaLayoutButtons[j].metagroupname;
            //console.log("index j", j);

            if (
              orgButtonName.toLowerCase() == donebuttonName.toLowerCase() &&
              orgButtonLabel === donebuttonLabel &&
              button.actiontype.toLowerCase() ==
                donebuttonActionType.toLowerCase()
            ) {
              bExistsInDefault = true;
              // this.firstfieldsDone.push(field);
              // if (metagroupname.toLowerCase() === "header") {
              this.firstbuttonsDone.push(button);
              // }

              break;
            }
          }

          if (!bExistsInDefault) {
            this.firstbuttonsToDo.push(button);
          }
        }

        //finally sort the done list as given in the default field name
        var sorted = _.sortBy(
          this.firstfieldsDone,
          function (obj: { fieldname: any }) {
            return _.indexOf(groupFieldNames, obj.fieldname);
          }
        );
        //console.log("sorted", sorted);
        this.firstfieldsDone = sorted;
      } else {
        // this.firstbuttonsToDo.push(button);
        this.firstbuttonsToDo = this.buttons;
      }
    }
  }

  retrieveMetabuttons() {
    return new Promise((resolve, reject) => {
      console.log("getMetabuttons");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metabutton: {
            metaobjectid: this.metaobjectId
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaButtonsLayout(postOption).subscribe(
        (res) => {
          console.log("res", res);
          this.buttons = res.data.metabuttons;

          // this.buttons = metabuttons;
          // this.buttonsToDo = this.buttons;

          if (res !== null && res.success == 1) {
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metabuttons data!");
            this.errorMessage =
              res != null ? res.message : "No metabuttons data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  createMetaProfileLayoutCriteria() {
    //get criteria details and assign it to postoption
    //get formarray details
    var arrMetaProfileLayoutCriteria = [];

    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;

      var operator = c.get("fieldoperator").value;
      if (operator.toLowerCase().trim() == "--none--") operator = "";
      var relatedfieldname = c.get("relatedfieldname").value;

      var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        var metaProfileLayoutCriteria = {
          id: this.guid.getGUID("metaprofilelayoutcriteria"),
          metaobjectid: this.metaobjectId,
          metalayoutid: this.metalayoutId,
          metafieldid: fieldName,
          fieldname: fieldId,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          // filterlogic: c.get("filterlogic").value,
          filterlogic: this.filterForm.controls["filterlogic"].value
        };
        if (relatedfieldname) {
          metaProfileLayoutCriteria.fieldname = `${relatedfieldname}.${fieldId}`;
        } else {
          metaProfileLayoutCriteria.fieldname = fieldId;
        }

        console.log(metaProfileLayoutCriteria);
        //push it to array
        arrMetaProfileLayoutCriteria.push(metaProfileLayoutCriteria);
      }
    }

    return arrMetaProfileLayoutCriteria;
  }

  properties(): void {
    this.attributesdialogRef = this.dialog.open(this.attributesDialog, {
      // data: this.data,
      height: "300px",
      width: "600px",
      panelClass: "custom-dialog-class"
    });

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.attributesdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  submit(): void {
    // if (
    //   this.attributeForm.controls["searchablefield"].value.toString().trim() ==
    //   ""
    // ) {
    //   this.showWarning("Searchable field name is mandatory");
    //   return;
    // }
    this.attributesdialogRef.close();
  }
  closeAttributeDialog() {
    this.attributesdialogRef.close();
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    //detailform validation
    if (this.detailForm.controls["layouttype"].value.toString().trim() == "") {
      this.showWarning("Layout Type is mandatory");
      return;
    }
    if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
      this.showWarning("Label is mandatory");
      return;
    }
    if (this.detailForm.controls["viewname"].value.toString().trim() == "") {
      this.showWarning("View name is mandatory");
      return;
    }

    //selected field list validation
    if (this.firstfieldsDone.length == 0) {
      this.showWarning("You must have atleast one field in the selected list");
      return;
    }

    const selectedLayoutType = this.detailForm.controls["layouttype"].value;
    const selectedLayoutTypeOption = this.layoutTypeSelect.find(
      (opt) => opt.value === selectedLayoutType
    );
    const selectedLayoutTypeLabel = selectedLayoutTypeOption.label;
    console.log("Selected Label:", selectedLayoutTypeOption.label);

    var viewName = this.detailForm.controls["viewname"].value;
    //viewName = viewName.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    //viewName = viewName.replace(/ /g, "_");
    console.log(viewName);

    // this.metalayoutName =
    //   this.metaobjectName + "_" + "CustomView" + "_" + viewName;
    this.metalayoutName = viewName;
    var targetURL =
      "api/v1/" + this.metaobjectName.toLowerCase() + "/all/custom";

    var metalayoutAttributes = {
      // searchablefield:
      //   this.attributeForm.controls["searchablefield"].value
      //     ?.toString()
      //     .trim() || "",
      searchablefield:
        (this.attributeForm.controls["searchablefield"].value != null
          ? this.attributeForm.controls["searchablefield"].value
              .toString()
              .trim()
          : "") || "",
      relatedlistflag: false,
      notesandattachments: false,
      activity: false
    };
    console.log(this.firstfieldsDone);

    console.log(this.secondfieldsDone);

    const firstField = this.firstfieldsDone.find((field, index) => {
      // Check if there's any other field with the same id before the current index
      return (
        this.firstfieldsDone.findIndex(
          (f, idx) => idx !== index && f.id === field.id
        ) !== -1
      );
    });
    if (firstField) {
      this.showWarning(
        `Duplicate Entry Found in Header: ${firstField.labelname}`
      );
      return;
    }

    const secondField = this.secondfieldsDone.find((field, index) => {
      // Check if there's any other field with the same id before the current index
      return (
        this.secondfieldsDone.findIndex(
          (f, idx) => idx !== index && f.id === field.id
        ) !== -1
      );
    });
    if (secondField) {
      this.showWarning(
        `Duplicate Entry Found in Footer: ${secondField.labelname} `
      );
      return;
    }
    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.metalayoutId = this.guid.getGUID("metalayout");
    }

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    // const saveHeaderSection = () => {
    const headerSectionData = {
      sectionName: "Header", // Or whatever name you have for the header section
      droppedDataFieldList: [], // Initialize droppedDataFieldList
      droppedDataButtonList: [] // Assuming you have a separate list for header buttons
    };

    // Add fields to header section data
    this.firstfieldsDone.forEach((field) => {
      headerSectionData.droppedDataFieldList.push({
        id: field.id,
        labelname: field.labelname,
        fieldname: field.fieldname,
        fieldtype: field.fieldtype,
        relatedfieldname: field.relatedfieldname,
        attributes: field.attributes,
        standard: field.standard,
        readonly: field.readonly,
        required: field.required,
        visible: field.visible
      });
    });

    this.firstbuttonsDone.forEach((button) => {
      headerSectionData.droppedDataButtonList.push({
        id: button.id,
        name: button.name,
        labelname: button.labelname,
        buttontype: button.buttontype,
        actiontype: button.actiontype,
        attributes: button.attributes,
        description: button.description
        // readonly: button.readonly,
        // required: button.required,
        // visible: button.visible
      });
    });

    console.log(headerSectionData);
    // };

    const footerSectionData = {
      sectionName: "Footer", // Or whatever name you have for the header section
      droppedDataFieldList: [], // Initialize droppedDataFieldList
      droppedDataButtonList: [] // Assuming you have a separate list for header buttons
    };

    // Add fields to header section data
    this.secondfieldsDone.forEach((field) => {
      footerSectionData.droppedDataFieldList.push({
        id: field.id,
        labelname: field.labelname,
        fieldname: field.fieldname,
        fieldtype: field.fieldtype,
        relatedfieldname: field.relatedfieldname,
        attributes: field.attributes,
        standard: field.standard,
        readonly: field.readonly,
        required: field.required,
        visible: field.visible
      });
    });

    this.secondbuttonsDone.forEach((button) => {
      footerSectionData.droppedDataButtonList.push({
        id: button.id,
        name: button.name,
        labelname: button.labelname,
        buttontype: button.buttontype,
        actiontype: button.actiontype,
        attributes: button.attributes,
        description: button.description
        // readonly: button.readonly,
        // required: button.required,
        // visible: button.visible
      });
    });

    console.log(headerSectionData);
    console.log(footerSectionData);

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metalayout: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          relatedobjectid: "",
          mode: this.mode,
          id: this.metalayoutId,
          displayname: this.detailForm.controls["displayname"].value.trim(),
          viewname: viewName,
          fieldhistory: false,
          approvalhistory: false,
          team: false,
          pathsetting: false,
          // viewname: this.detailForm.controls["displayname"].value.trim(),
          name: this.metalayoutName,
          // action: "Refine",
          action: selectedLayoutType,
          // layouttype: "Refine Layout",
          layouttype: selectedLayoutTypeLabel,
          targeturl: targetURL,
          columncount: parseInt(this.detailForm.controls["columncount"].value),
          tabkeyorder: this.detailForm.controls["tabkeyorder"].value.trim(),
          hascustomview: this.detailForm.controls["hascustomview"].value,
          clonable: this.detailForm.controls["clonable"].value,
          editable: this.detailForm.controls["editable"].value,
          deletable: this.detailForm.controls["deletable"].value,
          haskanbanview: this.detailForm.controls["haskanbanview"].value,
          searchtext: this.detailForm.controls["searchtext"].value.trim(),
          sortby: this.detailForm.controls["sortby"].value.trim(),
          sortorder: this.detailForm.controls["sortorder"].value.trim(),
          sinceversionseq:
            this.detailForm.controls["sinceversionseq"].value != null
              ? this.detailForm.controls["sinceversionseq"].value
              : 0,
          deprecatedversionseq:
            this.detailForm.controls["deprecatedversionseq"].value != null
              ? this.detailForm.controls["deprecatedversionseq"].value
              : 0,
          category: this.detailForm.controls["category"].value,
          devicetype: this.detailForm.controls["devicetype"].value,
          pagesize: this.appConfig.appDefaultPageSize,
          pagenumber: 1,
          filterbyowner: "",
          queueid: "",
          queuename: "",
          active: true,
          userid: localStorage.getItem("crm_userid"),
          publicaccess: this.detailForm.controls["publicaccess"].value,
          attributes: metalayoutAttributes,
          metalayoutbuttonsprovided: true,
          metaprofilelayouts: [],
          metaprofilelayoutcriterias: [],
          metalayoutgroups: [],
          metaprofilelayoutwebs: [],
          metalayoutbuttons: [] //will be served at server
        }
      }
    };

    //****** metaprofilelayoutcriteria  *********/
    //create criteria details & push it to postOption
    var arrMetaProfileLayoutCriteria = this.createMetaProfileLayoutCriteria();
    //push metalayoutgroup to request data (postoption)
    postOption.data.metalayout.metaprofilelayoutcriterias =
      arrMetaProfileLayoutCriteria;

    //****** metaprofilelayout  *********/

    //metaprofilelayout
    // if (this.mode.toLowerCase() == "new") {
    //   this.metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
    // }

    // var metaLayoutButtonId = "";
    //metalayoutbutton
    // this.metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");
    // console.log("metaLayoutButtonId", this.metaLayoutButtonId );

    // this.metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");

    const headerSectionMetaLayoutGroup = {
      id: this.guid.getGUID("metalayoutgroup"),
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      name: "Header",
      groupsequence: 1,
      showondetailpage: true,
      showoneditpage: true,
      columncount: 4,
      active: true,
      imagesection: false,
      systemsection: false,
      metalayoutgroupfields: []
    };

    this.firstfieldsDone.forEach((field, index) => {
      this.metaLayoutGroupFieldId = this.guid.getGUID("metalayoutgroupfield");

      let metaGroupFieldAttributes = {};

      if (field.fieldtype.toLowerCase() === "id") {
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: "",
          linkfield: "",
          hidden: true,
          linkrelativeurl: "",
          islink: false,
          headerfields: false,
          sequence: 0
        };
      } else if (field.fieldname.toLowerCase() === "name") {
        const linkrelativeurl = "dv/" + this.metaobjectName;
        metaGroupFieldAttributes = {
          recordtypeexist: "",
          object: this.metaobjectName,
          linkfield: "id",
          hidden: false,
          linkrelativeurl: linkrelativeurl,
          islink: true,
          headerfields: true,
          sequence: 1
        };
      } else {
        metaGroupFieldAttributes = {
          recordtypeexist: "",
          object: "",
          linkfield: "",
          hidden: false,
          linkrelativeurl: "",
          islink: false,
          headerfields: false,
          sequence: 2
        };
      }

      const metaLayoutGroupField = {
        id: this.metaLayoutGroupFieldId,
        metafieldid: field.id,
        metaobjectid: this.metaobjectId,
        embeddedobject: false,
        parentobjectid: "",
        metalayoutid: this.metalayoutId,
        metagroupid: headerSectionMetaLayoutGroup.id,
        labelname: field.labelname,
        fieldname: "",
        aliasname: field.aliasname || "",
        fieldtype: field.fieldtype,
        standard: field.standard,
        fieldsequence: index,
        defaultvalue: field.defaultvalue,
        hinttext: field.hinttext,
        helptext: field.helptext,
        primary: field.primaryfield,
        groupfieldattributes: metaGroupFieldAttributes,
        readonly: field.readonly,
        required: field.required,
        attributes: field.attributes,
        supportingobjectid: "",
        supportingfield: false,
        active: true,
        derivedfield: false,
        visible: field.visible
      };
      if (field.relatedfieldname) {
        metaLayoutGroupField.fieldname = `${field.relatedfieldname}.${field.fieldname}`;
      } else {
        metaLayoutGroupField.fieldname = field.fieldname;
      }

      headerSectionMetaLayoutGroup.metalayoutgroupfields.push(
        metaLayoutGroupField
      );
    });

    const footerSectionMetaLayoutGroup = {
      id: this.guid.getGUID("metalayoutgroup"), // Assuming you have this defined somewhere
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      name: "Footer",
      groupsequence: 2,
      showondetailpage: true,
      showoneditpage: true,
      columncount: 1,
      active: true,
      imagesection: false,
      systemsection: false,
      metalayoutgroupfields: []
    };

    // this.secondfieldsDone.forEach((field) => {
    //   this.metaLayoutGroupFieldId = this.guid.getGUID("metalayoutgroupfield");
    //   var index = 1;

    //   footerSectionMetaLayoutGroup.metalayoutgroupfields.push({
    //     id: this.metaLayoutGroupFieldId ,
    //     metafieldid: field.id,
    //     metaobjectid: this.metaobjectId,
    //     embeddedobject: false,
    //     parentobjectid: "",
    //     metalayoutid: this.metalayoutId,
    //     metagroupid: this.metaLayoutGroupId,

    //     labelname: field.labelname,
    //     fieldname: field.fieldname,
    //     fieldtype: field.fieldtype,
    //     // attributes: field.attributes,
    //     standard: field.standard,
    //     fieldsequence: index,
    //     defaultvalue: field.defaultvalue,
    //     primary: field.primaryfield,
    //     groupfieldattributes: {},
    //     readonly: field.readonly,
    //     required: field.required,
    //     visible: field.visible,
    //   });

    //   var metaGroupFieldAttributes = {};

    //   if (field.fieldtype.toLowerCase() == "id") {
    //     metaGroupFieldAttributes = {
    //       recordtypeexist: "false",
    //       object: "",
    //       linkfield: "",
    //       hidden: true,
    //       linkrelativeurl: "",
    //       islink: false,
    //       headerfields: false,
    //       sequence: 0,
    //     };
    //   }
    //   else if (field.fieldname.toLowerCase() == "name") {
    //     //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
    //     var linkrelativeurl = "dv/" + this.metaobjectName;
    //     metaGroupFieldAttributes = {
    //       recordtypeexist: "" ,
    //       object: this.metaobjectName,
    //       linkfield: "id",
    //       hidden: false,
    //       linkrelativeurl: linkrelativeurl,
    //       islink: true,
    //       headerfields: true,
    //       sequence:1

    //     };
    //   }
    //   //  else if (Object.keys(this.groupfieldattributes).length >0) {
    // else {
    //     metaGroupFieldAttributes = {
    //       recordtypeexist: "",
    //       object: "",
    //       linkfield: "",
    //       hidden: false,
    //       linkrelativeurl: "",
    //       islink: false,
    //       headerfields: false,
    //       sequence: 2,
    //     };
    //   }

    //   footerSectionMetaLayoutGroup.metalayoutgroupfields.groupfieldattributes = metaGroupFieldAttributes;
    //   index++;
    // });

    this.secondfieldsDone.forEach((field, index) => {
      this.metaLayoutGroupFieldId = this.guid.getGUID("metalayoutgroupfield");

      let metaGroupFieldAttributes = {};

      if (field.fieldtype.toLowerCase() === "id") {
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: "",
          linkfield: "",
          hidden: true,
          linkrelativeurl: "",
          islink: false,
          headerfields: false,
          sequence: 0
        };
      } else if (field.fieldname.toLowerCase() === "name") {
        const linkrelativeurl = "dv/" + this.metaobjectName;
        metaGroupFieldAttributes = {
          recordtypeexist: "",
          object: this.metaobjectName,
          linkfield: "id",
          hidden: false,
          linkrelativeurl: linkrelativeurl,
          islink: true,
          headerfields: true,
          sequence: 1
        };
      } else {
        metaGroupFieldAttributes = {
          recordtypeexist: "",
          object: "",
          linkfield: "",
          hidden: false,
          linkrelativeurl: "",
          islink: false,
          headerfields: false,
          sequence: 2
        };
      }

      const metaLayoutGroupField = {
        id: this.metaLayoutGroupFieldId,
        metafieldid: field.id,
        metaobjectid: field.metaobjectid,
        embeddedobject: false,
        parentobjectid: "",
        metalayoutid: this.metalayoutId,
        metagroupid: footerSectionMetaLayoutGroup.id,
        labelname: field.labelname,
        fieldname: "",
        aliasname: field.aliasname || "",
        fieldtype: field.fieldtype,
        standard: field.standard,
        fieldsequence: index,
        defaultvalue: field.defaultvalue,
        hinttext: field.hinttext,
        helptext: field.helptext,
        primary: field.primaryfield,
        groupfieldattributes: metaGroupFieldAttributes,
        readonly: field.readonly,
        required: field.required,
        // attributes: {},
        attributes: field.attributes,
        supportingobjectid: "",
        supportingfield: false,
        active: true,
        derivedfield: false,
        visible: field.visible
      };
      if (field.relatedfieldname) {
        metaLayoutGroupField.fieldname = `${field.relatedfieldname}.${field.fieldname}`;
      } else {
        metaLayoutGroupField.fieldname = field.fieldname;
      }

      footerSectionMetaLayoutGroup.metalayoutgroupfields.push(
        metaLayoutGroupField
      );
    });

    this.firstbuttonsDone.forEach((button) => {
      this.metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");

      postOption.data.metalayout.metalayoutbuttons.push({
        id: this.metaLayoutButtonId,
        metaobjectid: this.metaobjectId,
        metaobjectname: this.metaobjectName,
        embeddedobject: false,
        metalayoutname: this.metalayoutName,
        metalayoutid: this.metalayoutId,
        metabuttonid: button.id,
        name: button.name,
        labelname: button.labelname,
        buttontype: button.buttontype,
        actiontype: button.actiontype,
        attributes: button.attributes,
        parentobjectid: "",
        active: true,
        description: button.description
      });
    });

    postOption.data.metalayout.metalayoutgroups.push(
      headerSectionMetaLayoutGroup
    );
    postOption.data.metalayout.metalayoutgroups.push(
      footerSectionMetaLayoutGroup
    );

    var metaProfileLayoutId = "";
    //metaprofilelayout
    metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
    console.log("metaprofileLayoutId:", metaProfileLayoutId);

    var metaProfileLayout = {
      id: metaProfileLayoutId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      metalayoutname: this.metalayoutName,

      recordtypeid: "",
      profileid: "",
      description: "",
      // actiontype: "Refine",
      // layouttype: "Refine Layout",
      actiontype: selectedLayoutType,
      layouttype: selectedLayoutTypeLabel,
      active: true,
      attributes: {}
    };
    console.log("metaProfileLayout", metaProfileLayout);

    //push metaprofilelayout to request data (postoption)
    // postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    if (this.mode.toLocaleLowerCase() == "new") {
      postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    } else if (
      this.mode.toLocaleLowerCase() == "edit" &&
      this.metaProfileLayouts.length === 0
    ) {
      postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    } else {
      postOption.data.metalayout.metaprofilelayouts = this.metaProfileLayouts;
    }

    this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");

    var metaProfileLayoutWeb = {
      id: this.metaProfileLayoutWebId,
      metaobjectid: this.metaobjectId,
      metaobjectname: this.metaobjectName,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      metalayoutname: this.metalayoutName,
      recordtypeid: null,
      recordtypename: "",
      profileid: null,
      profilename: "",
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      description: "",
      active: true,

      // actiontype: "Refine",
      // layouttype: "Refine Layout",
      actiontype: selectedLayoutType,
      layouttype: selectedLayoutTypeLabel,
      layoutjsontext: {},
      fieldjsontext: {},
      criteriajsontext: {}
    };

    // postOption.data.metalayout.metaprofilelayoutwebs.push(metaProfileLayoutWeb);
    if (this.mode.toLocaleLowerCase() == "new") {
      postOption.data.metalayout.metaprofilelayoutwebs.push(
        metaProfileLayoutWeb
      );
    } else if (
      this.mode.toLocaleLowerCase() == "edit" &&
      this.metaProfileLayoutWebs.length === 0
    ) {
      postOption.data.metalayout.metaprofilelayoutwebs.push(
        metaProfileLayoutWeb
      );
    } else {
      // If in edit mode, we need to sanitize the existing metaProfileLayoutWebs
      // Clone and sanitize the large array
      const sanitizedMetaProfileLayoutWebs = this.metaProfileLayoutWebs.map(
        (item) => ({
          ...item,
          actiontype: selectedLayoutType,
          layouttype: selectedLayoutTypeLabel,

          layoutjsontext: {},
          fieldjsontext: {},
          criteriajsontext: {}
        })
      );

      // Assign sanitized array to the payload
      postOption.data.metalayout.metaprofilelayoutwebs =
        sanitizedMetaProfileLayoutWebs;
    }

    console.log(postOption);
    // var metaProfileLayout = {
    //   id: this.metaProfileLayoutId,
    //   metaobjectid: this.metaobjectId,
    //   embeddedobject: false,
    //   parentobjectid: "",
    //   metalayoutid: this.metalayoutId,
    //   recordtypeid: "",
    //   profileid: null,
    //   description: "",
    //   actiontype: "CustomView",
    //   active: true,
    // };

    //push metaprofilelayout to request data (postoption)
    // postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);

    //****** metalayoutgroup  *********/

    //get metalayoutgroup details and assign it to postoption
    // if (this.mode.toLowerCase() == "new") {
    //   this.metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");
    // }
    // var groupSequence = 1;

    // var metaLayoutGroup = {
    //   id: this.metaLayoutGroupId,
    //   metaobjectid: this.metaobjectId,
    //   embeddedobject: false,
    //   parentobjectid: "",
    //   metalayoutid: this.metalayoutId,
    //   name: viewName,
    //   groupsequence: groupSequence,
    //   showondetailpage: true,
    //   showoneditpage: true,
    //   columncount: this.detailForm.controls["columncount"].value,
    //   active: true,
    //   imagesection: false,
    //   systemsection: false,
    //   metalayoutgroupfields: [],
    // };

    //****** metalayoutgroupfield *********/

    //create metalayoutgroupfield and assign it to metaLayoutGroup
    // var arrMetaGroupField = this.createMetaLayoutGroupField(
    //   this.metaLayoutGroupId,
    //   groupSequence
    // );
    //postOption.data.metalayout.metalayoutgroupfields = arrMetaGroupField;
    // metaLayoutGroup.metalayoutgroupfields = arrMetaGroupField;

    //push metalayoutgroup to request data (postoption)
    // postOption.data.metalayout.metalayoutgroups.push(metaLayoutGroup);

    //****** metaprofilelayout  *********/

    //metaprofilelayoutweb
    // if (this.mode.toLowerCase() == "new") {
    //   this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");
    // }
    // var metaProfileLayoutWeb = {
    //   id: this.metaProfileLayoutWebId,
    //   metaobjectid: this.metaobjectId,
    //   metaobjectname: this.metaobjectName,
    //   embeddedobject: false,
    //   parentobjectid: "",
    //   metalayoutid: this.metalayoutId,
    //   metalayoutname: this.metalayoutName,
    //   recordtypeid: null,
    //   recordtypename: "",
    //   profileid: null,
    //   profilename: "",
    //   userid: localStorage.getItem("crm_userid"),
    //   username: localStorage.getItem("crm_username"),
    //   description: "",
    //   actiontype: "CustomView",
    //   active: true,
    //   layouttype: "CustomView",
    //   layoutjsontext: {},
    //   fieldjsontext: {},
    //   criteriajsontext: {},
    // };

    //push metaprofilelayout to request data (postoption)
    // postOption.data.metalayout.metaprofilelayoutwebs.push(metaProfileLayoutWeb);

    // console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertMetalayout(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("Error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
